import { useAnalyticsContext } from './AnalyticsProvider';

/**
 * Hook for tracking analytics events.
 * Must be used within AnalyticsProvider.
 */
export function useAnalytics() {
  return useAnalyticsContext();
}
